import Vue from 'vue'
import svgIcon from '../components/svgIcon'
Vue.component('svgIcon', svgIcon)
const req = require.context('../icons/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)